import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Spin from '../Svg/Spin';

const Loader = forwardRef(({
  addClasses = '',
  height,
  width,
}, ref) => {
  const classes = classnames(
    'loader-container',
    { [addClasses]: addClasses },
  );

  return (
    <div className={classes} ref={ref}>
      <Spin height={height} width={width} />
    </div>
  );
});

Loader.propTypes = {
  addClasses: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default Loader;
